import moment from 'moment';

export const responseDataToUserSubscription = data => {
  return {
    ...data,
    type: 'month' === data.frequency ? 'Mensuel' : 'Annuel',
    startDate: moment(data.startDate).format('DD MMMM YYYY'),
    _startDate: moment(data.startDate),
    endDate: moment(data.endDate).format('DD MMMM YYYY'),
    _endDate: moment(data.endDate),
    title: data.subscriptionName,
  };
};
